export const classhomework = [
	{
        id: "HW1783929",
        class: "Year 1",
        section: "Jupiter",
        subject: "English",
        homeworkDate: "10 Mar 2025",
        submissionDate: "12 Mar 2025",
        createdBy: "Janet",
        img : "assets/img/students/student-01.jpg",
        key:1
    },
    {
        id: "HW1783928",
        class: "Year 1",
        section: "Mars",
        subject: "Math",
        homeworkDate: "11 Mar 2025",
        submissionDate: "13 Mar 2025",
        createdBy: "Joann",
        img : "assets/img/students/student-02.jpg",
        key:2
    },
    {
        id: "HW1783927",
        class: "Year 2",
        section: "Jupiter",
        subject: "Physics",
        homeworkDate: "12 Mar 2025",
        submissionDate: "14 Mar 2025",
        createdBy: "Kathleen",
        img : "assets/img/students/student-03.jpg",
        key:3
    },
    {
        id: "HW1783926",
        class: "Year 2",
        section: "Mars",
        subject: "Chemistry",
        homeworkDate: "13 Mar 2025",
        submissionDate: "15 Mar 2025",
        createdBy: "Gifford",
        img : "assets/img/students/student-04.jpg",
        key:4
    },
    {
        id: "HW1783925",
        class: "Year 2",
        section: "Saturn",
        "subject": "Biology",
        homeworkDate: "14 Mar 2025",
        submissionDate: "16 Mar 2025",
        createdBy: "Lisa",
        img : "assets/img/students/student-05.jpg",
        key:5
    },
    {
        id: "HW1783924",
        class: "Year 3",
        section: "Jupiter",
        subject: "Higher Math",
        homeworkDate: "15 Mar 2025",
        submissionDate: "17 Mar 2025",
        createdBy: "Ralph",
        img : "assets/img/students/student-06.jpg",
        key:6
    },
    {
        id: "HW1783923",
        class: "Year 3",
        section: "Mars",
        subject: "Information Technology",
        homeworkDate: "16 Mar 2025",
        submissionDate: "18 Mar 2025",
        createdBy: "Julie",
        img : "assets/img/students/student-07.jpg",
        key:7
    },
    {
        id: "HW1783922",
        class: "Year 4",
        section: "Jupiter",
        subject: "Moral Education",
        homeworkDate: "17 Mar 2025",
        submissionDate: "19 Mar 2025",
        createdBy: "Ryan",
        img : "assets/img/students/student-08.jpg",
        key:8
    },
    {
        id: "HW1783921",
        class: "Year 4",
        section: "Mars",
        subject: "Finance",
        homeworkDate: "18 Mar 2025",
        submissionDate: "20 Mar 2025",
        createdBy: "Susan",
        img : "assets/img/students/student-09.jpg",
        key:9
    },
    {
        id: "HW1783920",
        class: "Year 5",
        section: "Jupiter",
        subject: "Economics",
        homeworkDate: "19 Mar 2025",
        submissionDate: "21 Mar 2025",
        createdBy: "Richard",
        img : "assets/img/students/student-07.jpg",
        key:10
    }
];
